<template>
  <div style="width: 95%; margin-top: 16px">
    <div
      flex
      v-for="(item, index) in answerList"
      :key="index"
      class="option-item"
      :class="{
        isTrue: readonly && answer.answerSituation === '1',
        isFalse: readonly && answer.answerSituation === '0',
      }"
    >
      <input
        v-if="!readonly"
        :maxlength="clozeMaxLength"
        :readonly="readonly"
        class="input"
        placeholder="请输入..."
        type="text"
        v-model="item.content"
        :disabled="showOptions"
        @keyup="blurInput"
      />
      <input
        v-else
        :readonly="readonly"
        class="input"
        type="text"
        v-model="answerData[index].content"
      />
    </div>
  </div>
</template>

<script>
let sortString = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
export default {
  name: "bc-answer-cloze",
  props: {
    typeOk: {
      type: String,
      default: "false",
    },
    length: {
      default: 0,
      type: Number,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    answer: {
      type: Object,
      default: () => {},
    },
    clozeMaxLength: {
      type: Number,
      default: 100,
    },
    isAnswerx: {
      type: Boolean,
      default: false,
    },
    isAnswerResults: {
      type: [String, Object],
      default: "",
    },
  },
  watch: {
    length: {
      handler(val) {
        this.answerList = [];
        for (let i = 0; i < val; i++) {
          this.answerList.push({ content: "", title: this.sortString[i] });
        }
      },
      immediate: true,
    },
    isAnswerResults: {
      handler(val) {
        if (!val) return;
        //题组试题组
        if (val.value) {
          this.answerList = JSON.parse(val.value);
          return;
        }
        //试题
        if (typeof val == "string") {
          this.answerList = JSON.parse(val);
        } else {
          this.answerList = val;
        }
      },
      immediate: true,
    },
    answer: {
      handler(val) {
        this.answerData = [];
        if (val.answerResults) {
          this.answerData = JSON.parse(val.answerResults);
        } else {
          for (let i = 0; i < this.answerList.length; i++) {
            this.answerData.push({ content: "", title: "" });
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    showOptions() {
      let isAnswer = false;
      if (this.typeOk == "true") {
        isAnswer = false;
      } else {
        isAnswer = this.isAnswerx;
      }
      return isAnswer;
    },
  },
  data() {
    return {
      answerList: [],
      sortString: sortString.split(""),
      answerData: [],
      isAnswer: false,
    };
  },
  methods: {
    blurInput() {
      if (this.answerList.some((i) => i.content)) {
        this.$emit("change", JSON.stringify(this.answerList));
      } else {
        this.$emit("change", "");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.option-item {
  width: 100%;
  padding: 15px;
  background: #fbfbfb;
  border-radius: 6px;

  & + .option-item {
    margin-top: 16px;
  }
  &.isTrue {
    border: 1px solid #70b603;
  }

  &.isFalse {
    border: 1px solid #d9001b;
  }
  .input {
    outline: none;
    height: 100%;
    width: 100%;
    background: transparent;
    border: none;
  }
}
</style>
